const Footer = () => {
  return (
    <footer className="text-center text-gray-400 dark:text-gray-300 py-4 text-sm">
      © {new Date().getFullYear()} Madhan Kumar. All rights reserved.
    </footer>
  );
};

export default Footer;
